import styled from 'styled-components';
import { ScrollableWrapper } from '../../../components/ui-helpers/scrollable-wrapper';

import { mediaSize } from '../../../styles';

export const ListUsersWrapper = styled(ScrollableWrapper)`
  margin: 0 auto;
  max-height: 465px;
  overflow: auto;
  padding: 0;
  
  @media (max-width: ${mediaSize.phone}) {
    margin: 22px 8px;
  }
`;

export const ListUsersContainer = styled.div`
  max-width: 566px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
`;



// WEBPACK FOOTER //
// ./src/modals/manage-users-modal/list-users/styled-components.js